import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données hiérarchisées 
const housingData = {
  "title": "Répartition des ménages ordinaires par milieu de résidence, province et commune selon le type d’habitat",
  "provinces": [
    {
      "name": "BURUNDI",
      "communes": [],
      "maisonOrdinaire": "2 396 931",
      "immeubleAppartement": "7 567",
      "villaSimple": "66 350",
      "villaEtage": "7 990",
      "maisonBande": "181 156",
      "case": "42 336",
      "hutte": "17 910",
      "logementFerme": "1 678",
      "autre": "2 677",
      "total": "2 724 595"
    },
    {
      "name": "URBAIN",
      "communes": [],
      "maisonOrdinaire": "472 863",
      "immeubleAppartement": "4 685",
      "villaSimple": "55 015",
      "villaEtage": "7 774",
      "maisonBande": "138 908",
      "case": "3 543",
      "hutte": "2 750",
      "logementFerme": "974",
      "autre": "1 991",
      "total": "688 503"
    },
    {
      "name": "RURAL",
      "communes": [],
      "maisonOrdinaire": "1 924 068",
      "immeubleAppartement": "2 882",
      "villaSimple": "11 335",
      "villaEtage": "216",
      "maisonBande": "42 248",
      "case": "38 793",
      "hutte": "15 160",
      "logementFerme": "704",
      "autre": "686",
      "total": "2 036 092"
    },
    {
      "name": "BUHUMUZA",
      "communes": [
        {
          "name": "BUTAGANZWA",
          "maisonOrdinaire": "22 464",
          "immeubleAppartement": "20",
          "villaSimple": "29",
          "villaEtage": "0",
          "maisonBande": "125",
          "case": "68",
          "hutte": "40",
          "logementFerme": "2",
          "autre": "4",
          "total": "22 752"
        },
        {
          "name": "BUTIHINDA",
          "maisonOrdinaire": "92 662",
          "immeubleAppartement": "208",
          "villaSimple": "624",
          "villaEtage": "31",
          "maisonBande": "2 608",
          "case": "1 718",
          "hutte": "1 588",
          "logementFerme": "82",
          "autre": "15",
          "total": "99 536"
        },
        {
          "name": "CANKUZO",
          "maisonOrdinaire": "31 441",
          "immeubleAppartement": "67",
          "villaSimple": "145",
          "villaEtage": "4",
          "maisonBande": "1 029",
          "case": "525",
          "hutte": "447",
          "logementFerme": "21",
          "autre": "19",
          "total": "33 698"
        },
        {
          "name": "GISAGARA",
          "maisonOrdinaire": "57 587",
          "immeubleAppartement": "77",
          "villaSimple": "123",
          "villaEtage": "3",
          "maisonBande": "1 121",
          "case": "2 482",
          "hutte": "505",
          "logementFerme": "4",
          "autre": "8",
          "total": "61 910"
        },
        {
          "name": "GISURU",
          "maisonOrdinaire": "67 716",
          "immeubleAppartement": "58",
          "villaSimple": "78",
          "villaEtage": "2",
          "maisonBande": "401",
          "case": "1 665",
          "hutte": "219",
          "logementFerme": "13",
          "autre": "14",
          "total": "70 166"
        },
        {
          "name": "MUYINGA",
          "maisonOrdinaire": "100 852",
          "immeubleAppartement": "113",
          "villaSimple": "628",
          "villaEtage": "9",
          "maisonBande": "2 800",
          "case": "1 987",
          "hutte": "1 125",
          "logementFerme": "36",
          "autre": "45",
          "total": "107 595"
        },
        {
          "name": "RUYIGI",
          "maisonOrdinaire": "44 339",
          "immeubleAppartement": "54",
          "villaSimple": "230",
          "villaEtage": "4",
          "maisonBande": "708",
          "case": "235",
          "hutte": "106",
          "logementFerme": "17",
          "autre": "8",
          "total": "45 701"
        }
      ],
      "maisonOrdinaire": "417 061",
      "immeubleAppartement": "597",
      "villaSimple": "1 857",
      "villaEtage": "53",
      "maisonBande": "8 792",
      "case": "8 680",
      "hutte": "4 030",
      "logementFerme": "175",
      "autre": "113",
      "total": "441 358"
    },
    {
      "name": "BUJUMBURA",
      "communes": [
        {
          "name": "BUBANZA",
          "maisonOrdinaire": "46 385",
          "immeubleAppartement": "138",
          "villaSimple": "1 259",
          "villaEtage": "15",
          "maisonBande": "785",
          "case": "541",
          "hutte": "272",
          "logementFerme": "4",
          "autre": "18",
          "total": "49 417"
        },
        {
          "name": "BUKINANYANA",
          "maisonOrdinaire": "52 932",
          "immeubleAppartement": "71",
          "villaSimple": "290",
          "villaEtage": "9",
          "maisonBande": "2 120",
          "case": "350",
          "hutte": "245",
          "logementFerme": "22",
          "autre": "17",
          "total": "56 056"
        },
        {
          "name": "CIBITOKE",
          "maisonOrdinaire": "45 906",
          "immeubleAppartement": "73",
          "villaSimple": "990",
          "villaEtage": "15",
          "maisonBande": "7 813",
          "case": "800",
          "hutte": "396",
          "logementFerme": "51",
          "autre": "42",
          "total": "56 086"
        },
        {
          "name": "ISARE",
          "maisonOrdinaire": "28 512",
          "immeubleAppartement": "50",
          "villaSimple": "740",
          "villaEtage": "9",
          "maisonBande": "821",
          "case": "211",
          "hutte": "237",
          "logementFerme": "13",
          "autre": "10",
          "total": "30 603"
        },
        {
          "name": "MPANDA",
          "maisonOrdinaire": "63 785",
          "immeubleAppartement": "125",
          "villaSimple": "2 144",
          "villaEtage": "42",
          "maisonBande": "8 239",
          "case": "831",
          "hutte": "331",
          "logementFerme": "323",
          "autre": "107",
          "total": "75 927"
        },
        {
          "name": "MUGERE",
          "maisonOrdinaire": "72 877",
          "immeubleAppartement": "1 008",
          "villaSimple": "19 468",
          "villaEtage": "2 593",
          "maisonBande": "12 657",
          "case": "403",
          "hutte": "390",
          "logementFerme": "89",
          "autre": "600",
          "total": "110 085"
        },
        {
          "name": "MUGINA",
          "maisonOrdinaire": "42 579",
          "immeubleAppartement": "107",
          "villaSimple": "741",
          "villaEtage": "6",
          "maisonBande": "1 580",
          "case": "1 136",
          "hutte": "335",
          "logementFerme": "9",
          "autre": "35",
          "total": "46 528"
        },
        {
          "name": "MUHUTA",
          "maisonOrdinaire": "20 352",
          "immeubleAppartement": "26",
          "villaSimple": "521",
          "villaEtage": "7",
          "maisonBande": "393",
          "case": "1 787",
          "hutte": "62",
          "logementFerme": "7",
          "autre": "9",
          "total": "23 164"
        },
        {
          "name": "MUKAZA",
          "maisonOrdinaire": "26 588",
          "immeubleAppartement": "557",
          "villaSimple": "1 508",
          "villaEtage": "969",
          "maisonBande": "11 540",
          "case": "111",
          "hutte": "46",
          "logementFerme": "24",
          "autre": "197",
          "total": "41 540"
        },
        {
          "name": "NTAHANGWA",
          "maisonOrdinaire": "115 602",
          "immeubleAppartement": "1 861",
          "villaSimple": "21 004",
          "villaEtage": "3 915",
          "maisonBande": "69 291",
          "case": "1 811",
          "hutte": "1 394",
          "logementFerme": "386",
          "autre": "855",
          "total": "216 119"
        },
        {
          "name": "RWIBAGA",
          "maisonOrdinaire": "21 930",
          "immeubleAppartement": "13",
          "villaSimple": "160",
          "villaEtage": "1",
          "maisonBande": "414",
          "case": "1 862",
          "hutte": "129",
          "logementFerme": "5",
          "autre": "12",
          "total": "24 526"
        }
      ],
      "maisonOrdinaire": "537 448",
      "immeubleAppartement": "4 029",
      "villaSimple": "48 825",
      "villaEtage": "7 581",
      "maisonBande": "115 653",
      "case": "9 843",
      "hutte": "3 837",
      "logementFerme": "933",
      "autre": "1 902",
      "total": "730 051"
    },
    {
      "name": "BURUNGA",
      "communes": [
        {
          "name": "BURURI",
          "maisonOrdinaire": "38 047",
          "immeubleAppartement": "52",
          "villaSimple": "680",
          "villaEtage": "4",
          "maisonBande": "1 242",
          "case": "1 160",
          "hutte": "164",
          "logementFerme": "39",
          "autre": "41",
          "total": "41 429"
        },
        {
          "name": "MAKAMBA",
          "maisonOrdinaire": "71 418",
          "immeubleAppartement": "172",
          "villaSimple": "1 015",
          "villaEtage": "24",
          "maisonBande": "3 906",
          "case": "723",
          "hutte": "364",
          "logementFerme": "45",
          "autre": "18",
          "total": "77 685"
        },
        {
          "name": "MATANA",
          "maisonOrdinaire": "38 556",
          "immeubleAppartement": "80",
          "villaSimple": "314",
          "villaEtage": "10",
          "maisonBande": "1 033",
          "case": "3 424",
          "hutte": "197",
          "logementFerme": "18",
          "autre": "24",
          "total": "43 656"
        },
        {
          "name": "MUSONGATI",
          "maisonOrdinaire": "66 315",
          "immeubleAppartement": "73",
          "villaSimple": "207",
          "villaEtage": "1",
          "maisonBande": "1 014",
          "case": "3 196",
          "hutte": "231",
          "logementFerme": "30",
          "autre": "16",
          "total": "71 083"
        },
        {
          "name": "NYANZA",
          "maisonOrdinaire": "64 166",
          "immeubleAppartement": "351",
          "villaSimple": "1 611",
          "villaEtage": "12",
          "maisonBande": "9 162",
          "case": "653",
          "hutte": "521",
          "logementFerme": "50",
          "autre": "36",
          "total": "76 562"
        },
        {
          "name": "RUMONGE",
          "maisonOrdinaire": "79 551",
          "immeubleAppartement": "287",
          "villaSimple": "1 372",
          "villaEtage": "36",
          "maisonBande": "4 916",
          "case": "950",
          "hutte": "312",
          "logementFerme": "31",
          "autre": "85",
          "total": "87 540"
        },
        {
          "name": "RUTANA",
          "maisonOrdinaire": "42 562",
          "immeubleAppartement": "48",
          "villaSimple": "547",
          "villaEtage": "11",
          "maisonBande": "2 494",
          "case": "1 170",
          "hutte": "403",
          "logementFerme": "11",
          "autre": "11",
          "total": "47 257"
        }
      ],
      "maisonOrdinaire": "400 615",
      "immeubleAppartement": "1 063",
      "villaSimple": "5 746",
      "villaEtage": "98",
      "maisonBande": "23 767",
      "case": "11 276",
      "hutte": "2 192",
      "logementFerme": "224",
      "autre": "231",
      "total": "445 212"
    },
    {
      "name": "BUTANYERERA",
      "communes": [
        {
          "name": "BUSONI",
          "maisonOrdinaire": "76 766",
          "immeubleAppartement": "140",
          "villaSimple": "712",
          "villaEtage": "5",
          "maisonBande": "1 141",
          "case": "1 442",
          "hutte": "1 008",
          "logementFerme": "18",
          "autre": "17",
          "total": "81 249"
        },
        {
          "name": "KAYANZA",
          "maisonOrdinaire": "69 772",
          "immeubleAppartement": "229",
          "villaSimple": "1 036",
          "villaEtage": "28",
          "maisonBande": "2 475",
          "case": "278",
          "hutte": "375",
          "logementFerme": "20",
          "autre": "80",
          "total": "74 293"
        },
        {
          "name": "KIREMBA",
          "maisonOrdinaire": "64 973",
          "immeubleAppartement": "69",
          "villaSimple": "406",
          "villaEtage": "6",
          "maisonBande": "891",
          "case": "1 671",
          "hutte": "765",
          "logementFerme": "15",
          "autre": "21",
          "total": "68 817"
        },
        {
          "name": "KIRUNDO",
          "maisonOrdinaire": "102 666",
          "immeubleAppartement": "155",
          "villaSimple": "831",
          "villaEtage": "15",
          "maisonBande": "2 290",
          "case": "2 371",
          "hutte": "1 558",
          "logementFerme": "24",
          "autre": "31",
          "total": "109 941"
        },
        {
          "name": "MATONGO",
          "maisonOrdinaire": "56 370",
          "immeubleAppartement": "64",
          "villaSimple": "77",
          "villaEtage": "1",
          "maisonBande": "4 166",
          "case": "329",
          "hutte": "162",
          "logementFerme": "15",
          "autre": "18",
          "total": "61 202"
        },
        {
          "name": "MUHANGA",
          "maisonOrdinaire": "48 500",
          "immeubleAppartement": "65",
          "villaSimple": "88",
          "villaEtage": "4",
          "maisonBande": "6 001",
          "case": "211",
          "hutte": "316",
          "logementFerme": "12",
          "autre": "2",
          "total": "55 199"
        },
        {
          "name": "NGOZI",
          "maisonOrdinaire": "69 062",
          "immeubleAppartement": "238",
          "villaSimple": "1 038",
          "villaEtage": "59",
          "maisonBande": "5 309",
          "case": "353",
          "hutte": "594",
          "logementFerme": "42",
          "autre": "47",
          "total": "76 742"
        },
        {
          "name": "TANGARA",
          "maisonOrdinaire": "57 512",
          "immeubleAppartement": "65",
          "villaSimple": "127",
          "villaEtage": "2",
          "maisonBande": "789",
          "case": "1 549",
          "hutte": "674",
          "logementFerme": "12",
          "autre": "24",
          "total": "60 754"
        }
      ],
      "maisonOrdinaire": "545 621",
      "immeubleAppartement": "1 025",
      "villaSimple": "4 315",
      "villaEtage": "120",
      "maisonBande": "23 062",
      "case": "8 204",
      "hutte": "5 452",
      "logementFerme": "158",
      "autre": "240",
      "total": "588 197"
    },
    {
      "name": "GITEGA",
      "communes": [
        {
          "name": "BUGENDANA",
          "maisonOrdinaire": "52 589",
          "immeubleAppartement": "115",
          "villaSimple": "542",
          "villaEtage": "14",
          "maisonBande": "321",
          "case": "128",
          "hutte": "265",
          "logementFerme": "13",
          "autre": "26",
          "total": "54 013"
        },
        {
          "name": "GISHUBI",
          "maisonOrdinaire": "58 401",
          "immeubleAppartement": "93",
          "villaSimple": "115",
          "villaEtage": "3",
          "maisonBande": "259",
          "case": "54",
          "hutte": "90",
          "logementFerme": "2",
          "autre": "14",
          "total": "59 031"
        },
        {
          "name": "GITEGA",
          "maisonOrdinaire": "111 513",
          "immeubleAppartement": "143",
          "villaSimple": "3 334",
          "villaEtage": "89",
          "maisonBande": "4 617",
          "case": "277",
          "hutte": "192",
          "logementFerme": "97",
          "autre": "91",
          "total": "120 353"
        },
        {
          "name": "KARUSI",
          "maisonOrdinaire": "78 299",
          "immeubleAppartement": "172",
          "villaSimple": "379",
          "villaEtage": "4",
          "maisonBande": "1 233",
          "case": "1 250",
          "hutte": "1 026",
          "logementFerme": "25",
          "autre": "12",
          "total": "82 400"
        },
        {
          "name": "KIGANDA",
          "maisonOrdinaire": "32 810",
          "immeubleAppartement": "92",
          "villaSimple": "239",
          "villaEtage": "5",
          "maisonBande": "661",
          "case": "173",
          "hutte": "95",
          "logementFerme": "5",
          "autre": "7",
          "total": "34 087"
        },
        {
          "name": "MURAMVYA",
          "maisonOrdinaire": "35 636",
          "immeubleAppartement": "85",
          "villaSimple": "389",
          "villaEtage": "18",
          "maisonBande": "1 757",
          "case": "143",
          "hutte": "104",
          "logementFerme": "16",
          "autre": "6",
          "total": "38 154"
        },
        {
          "name": "MWARO",
          "maisonOrdinaire": "32 724",
          "immeubleAppartement": "35",
          "villaSimple": "78",
          "villaEtage": "2",
          "maisonBande": "496",
          "case": "1 314",
          "hutte": "135",
          "logementFerme": "8",
          "autre": "9",
          "total": "34 801"
        },
        {
          "name": "NYABIHANGA",
          "maisonOrdinaire": "40 185",
          "immeubleAppartement": "49",
          "villaSimple": "336",
          "villaEtage": "2",
          "maisonBande": "332",
          "case": "592",
          "hutte": "139",
          "logementFerme": "4",
          "autre": "11",
          "total": "41 650"
        },
        {
          "name": "SHOMBO",
          "maisonOrdinaire": "54 029",
          "immeubleAppartement": "69",
          "villaSimple": "195",
          "villaEtage": "1",
          "maisonBande": "206",
          "case": "402",
          "hutte": "353",
          "logementFerme": "18",
          "autre": "15",
          "total": "55 288"
        }
      ],
      "maisonOrdinaire": "496 186",
      "immeubleAppartement": "853",
      "villaSimple": "5 607",
      "villaEtage": "138",
      "maisonBande": "9 882",
      "case": "4 333",
      "hutte": "2 399",
      "logementFerme": "188",
      "autre": "191",
      "total": "519 777"
    }
  ],
  "total": {
    "maisonOrdinaire": "2 396 931",
    "immeubleAppartement": "7 567",
    "villaSimple": "66 350",
    "villaEtage": "7 990",
    "maisonBande": "181 156",
    "case": "42 336",
    "hutte": "17 910",
    "logementFerme": "1 678",
    "autre": "2 677",
    "total": "2 724 595"
  }
};
const HouseholdHousingPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = "Province/Commune\tMaison ordinaire\tImmeuble appartement\tVilla simple\tVilla avec étage\tMaison en bande\tCase\tHutte\tLogement ferme\tAutre\tTotal\n";
    
    // Ajout des données totales
    tableContent += `BURUNDI\t${housingData.total.maisonOrdinaire}\t${housingData.total.immeubleAppartement}\t${housingData.total.villaSimple}\t${housingData.total.villaEtage}\t${housingData.total.maisonBande}\t${housingData.total.case}\t${housingData.total.hutte}\t${housingData.total.logementFerme}\t${housingData.total.autre}\t${housingData.total.total}\n`;
    
    // Ajout des données par province et commune
    housingData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.maisonOrdinaire}\t${province.immeubleAppartement}\t${province.villaSimple}\t${province.villaEtage}\t${province.maisonBande}\t${province.case}\t${province.hutte}\t${province.logementFerme}\t${province.autre}\t${province.total}\n`;
      
      province.communes.forEach(commune => {
        tableContent += `  ${commune.name}\t${commune.maisonOrdinaire}\t${commune.immeubleAppartement}\t${commune.villaSimple}\t${commune.villaEtage}\t${commune.maisonBande}\t${commune.case}\t${commune.hutte}\t${commune.logementFerme}\t${commune.autre}\t${commune.total}\n`;
      });
    });
    
    navigator.clipboard.writeText(`${housingData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données des types d'habitat des ménages au Burundi: ${housingData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(housingData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `types-habitat-menages-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  const filteredProvinces = housingData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);

  // Calcul des indicateurs clés
  const keyStats = (() => {
    const safeParseFloat = (value) => parseFloat(String(value).replace(/\s/g, '')) || 0;

    const totalHouseholds = safeParseFloat(housingData.total.total);

    const urbanTotal = safeParseFloat(housingData.provinces[1].total);
    const ruralTotal = safeParseFloat(housingData.provinces[2].total);

    const urbanPercentage = totalHouseholds > 0
      ? ((urbanTotal / totalHouseholds) * 100).toFixed(1)
      : "0.0";

    const ruralPercentage = totalHouseholds > 0
      ? ((ruralTotal / totalHouseholds) * 100).toFixed(1)
      : "0.0";

    const commonHousingTypes = [
      { name: "Maison ordinaire", value: safeParseFloat(housingData.total.maisonOrdinaire) },
      { name: "Maison en bande", value: safeParseFloat(housingData.total.maisonBande) },
      { name: "Villa simple", value: safeParseFloat(housingData.total.villaSimple) },
      { name: "Case", value: safeParseFloat(housingData.total.case) }
    ];

    const mostCommonHousing = commonHousingTypes.reduce(
      (max, type) => (type.value > max.value ? type : max),
      { name: "", value: -1 }
    );

    const highestUrbanProvince = housingData.provinces.slice(3).reduce((max, province) => {
      const maisonBande = safeParseFloat(province.maisonBande);
      const villaSimple = safeParseFloat(province.villaSimple);
      const villaEtage = safeParseFloat(province.villaEtage);
      const total = safeParseFloat(province.total);

      const urbanPct = total > 0 ? ((maisonBande + villaSimple + villaEtage) / total) * 100 : 0;

      return urbanPct > max.urbanPct
        ? { province, urbanPct: urbanPct.toFixed(1) }
        : max;
    }, { province: null, urbanPct: -1 });

    return {
      totalHouseholds,
      urbanPercentage,
      ruralPercentage,
      mostCommonHousing,
      highestUrbanProvince,
    };
  })();

  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              href={item.to}  
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
        
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {housingData.title}
                    </Typography>
                  </Box>
                  <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6} ></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher province/commune..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '480px' } }}
                      />
                    </Grid>
                  </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés sur les Types d'Habitat
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Ménages Totaux
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {housingData.total.total}
                              </Typography>
                              <Typography variant="caption">
                                Ménages ordinaires
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Urbaine
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.urbanPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                {housingData.provinces[1].total} ménages
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Type d'habitat dominant
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostCommonHousing.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {housingData.total.maisonOrdinaire}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({(keyStats.mostCommonHousing.value / keyStats.totalHouseholds * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus urbanisée
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestUrbanProvince.province?.name || 'BUJUMBURA'}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.highestUrbanProvince.urbanPct}%
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des types d'habitat">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          <TableCell align="right">Maison ordinaire</TableCell>
                          <TableCell align="right">Immeuble appartement</TableCell>
                          <TableCell align="right">Villa simple</TableCell>
                          <TableCell align="right">Villa avec étage</TableCell>
                          <TableCell align="right">Maison en bande</TableCell>
                          <TableCell align="right">Case</TableCell>
                          <TableCell align="right">Hutte</TableCell>
                          <TableCell align="right">Logement ferme</TableCell>
                          <TableCell align="right">Autre</TableCell>
                          <TableCell align="right">Total</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.maisonOrdinaire}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.immeubleAppartement}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.villaSimple}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.villaEtage}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.maisonBande}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.case}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.hutte}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.logementFerme}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.autre}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.total}</TableCell>
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => province.communes.length > 0 && toggleProvince(province.name)}
                              sx={{ cursor: province.communes.length > 0 ? 'pointer' : 'default' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {province.communes.length > 0 && 
                                    (expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />)}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.maisonOrdinaire}</TableCell>
                              <TableCell align="right">{province.immeubleAppartement}</TableCell>
                              <TableCell align="right">{province.villaSimple}</TableCell>
                              <TableCell align="right">{province.villaEtage}</TableCell>
                              <TableCell align="right">{province.maisonBande}</TableCell>
                              <TableCell align="right">{province.case}</TableCell>
                              <TableCell align="right">{province.hutte}</TableCell>
                              <TableCell align="right">{province.logementFerme}</TableCell>
                              <TableCell align="right">{province.autre}</TableCell>
                              <TableCell align="right">{province.total}</TableCell>
                            </ProvinceRow>
                            
                            {province.communes.length > 0 && (
                              <TableRow>
                                <TableCell style={{ padding: 0 }} colSpan={11}>
                                  <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                    <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                      <TableBody>
                                        {province.communes.map((commune, idx) => (
                                          <CommuneRow key={idx} hover>
                                            <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                            <TableCell align="right">{commune.maisonOrdinaire}</TableCell>
                                            <TableCell align="right">{commune.immeubleAppartement}</TableCell>
                                            <TableCell align="right">{commune.villaSimple}</TableCell>
                                            <TableCell align="right">{commune.villaEtage}</TableCell>
                                            <TableCell align="right">{commune.maisonBande}</TableCell>
                                            <TableCell align="right">{commune.case}</TableCell>
                                            <TableCell align="right">{commune.hutte}</TableCell>
                                            <TableCell align="right">{commune.logementFerme}</TableCell>
                                            <TableCell align="right">{commune.autre}</TableCell>
                                            <TableCell align="right">{commune.total}</TableCell>
                                          </CommuneRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </Collapse>
                                </TableCell>
                              </TableRow>
                            )}
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                    {/* 
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Définitions des types d'habitat
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Les types d'habitat sont classés selon les catégories suivantes:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Maison ordinaire: Habitation traditionnelle ou moderne de construction simple" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Immeuble d'appartement: Bâtiment collectif avec plusieurs logements indépendants" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Villa simple: Maison individuelle de standing moyen" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Villa avec étage: Maison individuelle à plusieurs niveaux" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Maison en bande: Maisons mitoyennes alignées avec des murs communs" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Case: Habitation traditionnelle de petite taille" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Hutte: Construction rudimentaire en matériaux naturels" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Logement dans une ferme: Habitation attachée à une exploitation agricole" 
                        />
                      </ListItem>
                    </List>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et Elevage (RGPHAE) 
                    réalisé en 2024. Les chiffres incluent uniquement les ménages ordinaires (non collectifs). 
                    Les données sont ventilées par milieu de résidence (urbain/rural), province et commune.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default HouseholdHousingPage;